// extracted by mini-css-extract-plugin
export default {"modalWrapper":"RotateModal_modalWrapper__73y11","modalTitle":"RotateModal_modalTitle__jL+7W"};